import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';

import shallowEqual from 'shallowequal';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { getApiConfig } from 'reducers/response';
import API, { updateDefaults } from './api/microfwk';

const withAxiosClient = WrappedComponent => {
  class AxiosClientSetup extends React.PureComponent {
    state = { loading: true };

    static propTypes = {
      apiConfig: PropTypes.shape({
        baseURL: PropTypes.string.isRequired,
        params: PropTypes.shape(),
      }),
    };

    UNSAFE_componentWillMount() {
      const { apiConfig } = this.props;
      if (_.isEmpty(apiConfig)) return;

      this.setupAxiosApi(apiConfig);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (!shallowEqual(nextProps.apiConfig, this.props.apiConfig)) {
        this.setupAxiosApi(nextProps.apiConfig);
      }
    }

    setupAxiosApi = config => {
      updateDefaults(API, config);

      this.setState({ loading: false });
    };

    render() {
      const { loading } = this.state;
      if (loading) return null;

      return <WrappedComponent {...this.props} />;
    }
  }

  hoistNonReactStatics(AxiosClientSetup, WrappedComponent);

  const mapStateToProps = state => ({
    apiConfig: getApiConfig(state.config),
  });

  const withConnect = connect(mapStateToProps);

  return compose(withConnect)(AxiosClientSetup);
};

export default withAxiosClient;
